const ChatRoutes = {
  getConversations: 'getConversations',
  getSingleConversation: 'getConversation/',
  getConversationMessages: 'getConversationMessages/',
  createConversation: 'createConversation',
  sendMessage: 'sendMessage/',
};

export default ChatRoutes